module.exports = __webpack_public_path__ + "img/grand-vitara-dark-carmine.29c07095.png";